module.exports = __webpack_public_path__ + "img/third-one.18b5ab7b.png";